import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js';
import { api_gateway } from '../../../conexoes/api';
import { setaDropdown } from '../../../utils/alternanciaIcones';

/*  COMO USAR
    Importe a modal para dentro do componente que irá fazer uso dela.
    ex: import SelectPlano from '../../componentesModais/selects/selectPlano'

    Crie um hook apropriado para esconder e exibir a mensagem quando necessário.
    ex: const [revelarSelectPlano, setRevelarSelectPlano] = useState(false)

    Após isso, posicione-a dentro do return do seu componente e passe os props para
    customizar o conteúdo da mensagem da seguinte forma. É interessante utilizar um
    <Button/> com uma função onClick, dentro de um >Form.Group/> para que o campo
    se mantenha similar aos campos de texto normais.
    ex: <Form.Group>
            <Form.Label>
                <div className="fonte-cor-1 label-campo">Tipo de Pessoa {iconeAsterisco}</div>
            </Form.Label>
            { revelarSelectPlano === false &&
                <Button name="cdPlano" className="campo-texto-cor-3 campo-select" onClick={() => setRevelarSelectPlano(!revelarSelectPlano)}>
                    <div className="fonte-cor-1 label-campo">{dsPlano}</div>
                    <img className="campo-select-icone-desativado" src={setaDropdown()} alt="drop" />
                </Button>
            }
            { revelarSelectPlano === true &&
                <SelectPlano
                    setRevelarSelectPlano={setRevelarSelectPlano} //Hook para fechar a modal
                    setCdPlano={setCdPlano} //Código do Plano
                    setDsPlano={setDsPlano} //Nome do Plano
                    dsPlano={dsPlano}
                    phPlano={phPlano} //Placeholder para mostrar o valor original em caso de edição
                >
                </SelectPlano>
            }
        </Form.Group>*/

export default function SelectPlano(props) {
    // SPINNER
    const [spinAtivo, setSpinAtivo] = useState(false);
    //HOOKS MODAL
    const [lsPlano, setLsPlano] = useState([])
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };


    function handlePlano(codigo, nome){
        props.setCdNovoPlano(codigo)
        props.setDsNovoPlano(nome)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectNovoPlano(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function renderPlano(){
            let consulta;
            if(props.operadoras){
                consulta = await api_gateway.get('/m1/consultar/planos?cd_dsp_operadoras='+props.operadoras);
            }
            else{
                consulta = await api_gateway.get('/m1/consultar/planos?ope.cd_dsp_operadora='+props.operadora);
            }

            if(consulta.data.dados.length > 0){
                let objetoPlano = consulta.data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.ds_dsp_plano}>
                            <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handlePlano(item.cd_dsp_plano, item.ds_dsp_plano) }>
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">{item.ds_dsp_plano}</span>
                            </div>
                            {consulta.data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsPlano(objetoPlano)
            }else{
                let objetoPlano = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsPlano(objetoPlano)
            }
            setSpinAtivo(false)
        }
        renderPlano()
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);
    }, [])

    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectNovoPlano(false)}>
                <div className="fonte-cor-1 label-campo">{props.dsNovoPlano}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    {lsPlano}
                </ul>
            </div>
        </Form>
    )
}